import L from 'lodash'

import {
  addClass,
  removeClass,
} from '@straal/assets/staticViews/scripts/helpers.ts'

import { CLASSES as classes } from '@straal/globals/configs/elementConsts'

export const renderInputValidity = function(inputEl, { valid, errors }) {
  const inputContainerEl = inputEl.closest('.form__input')

  if (valid) {
    removeClass(inputContainerEl, classes.INPUT_ERROR)
  } else {
    const getTemplateFromErrorsArray = () => {
      const errorsReducer = function(result, error) {
        result += `<li>${error}</li>`
        return result
      }
      const errs = L.reduce(errors, errorsReducer, '')

      return `
        <ul class="form__input-error-contents">
          ${errs}
        </ul>
      `
    }
    const errorHTML = L.isArray(errors) ? getTemplateFromErrorsArray() : errors

    const fieldEl = inputEl.closest('.form__field')
    const fieldElementExists = Boolean(fieldEl)

    if (fieldElementExists) {
      fieldEl.querySelector(
        `.${classes.INPUT_ERROR_TOOLTIP}`,
      ).innerHTML = errorHTML
    }

    addClass(inputContainerEl, classes.INPUT_ERROR)
  }
}
